export function onLoadTrackAnalytics(productObjforAnalytics) {
	if (typeof tealium_data2track !== "undefined" && tealium_data2track !== null) {
		tealium_data2track.push({
			id: "VirtualPage-View",
			Order_Currency: !window.page_track.Order_Currency ? "" : window.page_track.Order_Currency,
			Page_Brand: !window.page_track.Page_Brand ? "" : window.page_track.Page_Brand,
			Page_Country: !window.page_track.Page_Country ? "" : window.page_track.Page_Country,
			Page_Platform: !window.page_track.Page_Platform ? "" : window.page_track.Page_Platform,
			Page_Language: !window.page_track.Page_Language ? "" : window.page_track.Page_Language,
			Page_DeviceType: !window.page_track.Page_DeviceType ? "" : window.page_track.Page_DeviceType,
			Page_Type: !window.page_track.Page_Type ? "" : window.page_track.Page_Type,
			Page_Section1: !window.page_track.Page_Section1 ? "" : window.page_track.Page_Section1,
			Page_Section2: !window.page_track.Page_Section2 ? "" : window.page_track.Page_Section2,
			Products: productObjforAnalytics ? productObjforAnalytics : "",
			User_LoginStatus: user != undefined ? user.loginStatus : "",
			User_Email_MD5: user != undefined ? user.email_MD5 : "",
			User_Email_SHA256: user != undefined ? user.email_SHA256 : "",
			User_EmailOptin: user != undefined ? user.emailOptin : "",
			User_HasPrescription: user != undefined ? user.User_HasPrescription : "",
			Search_ResultItemsQnt: Object.keys(productObjforAnalytics).length.toString() || "0",
			Order_CartUrl: $("#cart-url").length != 0 ? $("#cart-url").val() : "",
		});
	}
}

export function applyFilterTrackAnalytics(filterApplied, recordResult) {
	if (typeof tealium_data2track !== "undefined" && tealium_data2track !== null) {
		tealium_data2track.push({
			id: "Event",
			Events_SearchFiltering: "1",
			Search_ResultItemsQnt: recordResult.toString(),
			Search_FacetValues_String: filterApplied.toString(), // please fill with key value pairs of filters applied.
		});
	}
}
